/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//Import images
import alarmIcon from "../../../assets/images/icon/alarm-icon.svg";

//i18n
import { withNamespaces } from 'react-i18next';
import Icon from '../../Icon';
import Button from '../../Button';
import useForm from '../../../hooks/useForm';
import { getParams } from '../../../utils/params';
import { getNotifications, readNotifications } from '../../../apis/notification';
import { get } from 'lodash-es';
import CustomList from '../../List';
import NotificationItem from '../../Notification/NotificationItem';
import { isEmpty } from '../../../utils/lodashExtend';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getUnreadNotificationCount } from '../../../store/actions';


const NotificationDropdown = (props) => {
  const {
    unreadNotificationCount,
    employee,
  } = useSelector(
    (store) => ({
      unreadNotificationCount: store.Data.unreadNotificationCount,
      employee: store.Profile.employee,
    }),
    shallowEqual
  );
  // Declare a new state variable, which we'll call "menu"
  // const [menu, setMenu] = useState(true);
  const dispatch = useDispatch();
  const [menu, setMenu] = useState(false);
  const [fields, setFields] = useState([]);
  const [page, setPage] = useState(0);
  const [isMax, setIsMax] = useState(false);

  useEffect(() => {
    if (employee) {
      setFields([{
        onValue: (data, field, datas) => {
          return <NotificationItem {...datas} employee={employee}></NotificationItem>;
        }
      }]);
    }
  }, [employee]);

  const readAll = async () => {
    getNotifications({
      search: {
        isRead: false,
      }
    })
      .then(async (res) => {
        const notifications = get(res, "data.notifications");
        const messageIds = notifications.map(n => n.messageId);
        if (!isEmpty(messageIds)) {
          await readNotifications(messageIds);
          setList(list.map(item => ({ ...item, isRead: true })));
        }

        dispatch(getUnreadNotificationCount());
      });
  };

  const submit = (param) => {
    getNotifications(getParams({
      ...param,
      page
    }))
      .then((res) => {
        const _total = res.data.total;
        setTotal(_total);
        const notifications = get(res, "data.notifications");
        const _list = [...list, ...notifications];
        setList(_list);
        if (_list.length >= _total) {
          setIsMax(true);
        }
        dispatch(getUnreadNotificationCount());
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const {
    form,
    setSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
  } = useForm(
    {
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  );


  useEffect(() => {
    if (menu) {
      submit(form);
    } else {
      setPage(0);
      setList([]);
      setIsMax(false);
    }
    setSubmit(submit);
  }, [menu, page]);

  return (
    <>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button" id="page-header-notifications-dropdown">
          <Icon src={alarmIcon} />
          {unreadNotificationCount > 0 &&
            <span className="badge-ball">
              {unreadNotificationCount > 100 ? '99+' : unreadNotificationCount}
            </span>
          }
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu p-0"
          style={{
            width: '360px'
          }}
          right>
          <div className="p-3 dropdown-menu-header">
            <Row className="align-items-center">
              <Col>

                <h6 className="m-0">읽지 않은 알림
                  {unreadNotificationCount > 0 ?
                    <span className="badge-ball">
                      {unreadNotificationCount}
                    </span>
                    : ' 없음'}
                </h6>

              </Col>
              <div className="col-auto">
                {unreadNotificationCount > 0 &&
                  <Button
                    onClick={readAll}
                    color='green'
                    className="color-main-100 font-size-13"
                    style={{
                      padding: 0,
                      background: 'none'
                    }}
                  >
                    모두 읽음
                  </Button>
                }
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "430px" }}>
            <CustomList
              list={list}
              isLoading={isLoading}
              fields={fields}
            />
            {!isMax &&
              <div className="p-2">
                <Button
                  color="text"
                  className="width-full font-size-13text-center color-gray-6"
                  onClick={() => {
                    setPage(page + 1);
                  }}
                >
                  더보기
                </Button>
              </div>
            }
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default withNamespaces()(NotificationDropdown);